import { makeApi, URLS } from "Utils/apiURL";

class GeminiService {
  async chat(userMessage) {
    const config = {
      url: URLS.aiChat,
      method: "POST",
      data: {
        message: userMessage
      }
    };

    try {
      const response = await makeApi(config);
      
      if (response && response.status === 200 && response.data) {
          // Backend should return the answer, preferably in { answer: "..." } format
          // or just the raw string. We handle both.
          const { answer, text, response: aiResponse } = response.data;
          return answer || text || aiResponse || (typeof response.data === 'string' ? response.data : "I received a response but couldn't parse it.");
      } else {
        throw new Error(response.data?.error || "Failed to reach AI Backend");
      }

    } catch (error) {
      console.error("AI Backend Error:", error);
      throw new Error("Unable to connect to AI Service. Please try again later.");
    }
  }

  // Deprecated but kept for compatibility during transition
  setApiKey(key) { console.log("API Key management is now handled by backend."); }
  getApiKey() { return "BACKEND_MANAGED"; }
}

export default new GeminiService();
